import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/site";
import { SERVICES } from "@/content/services";
import { WA } from "@/lib/whatsapp";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-lux-warm-white" data-testid="footer">
      <div className="container-lux py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:pr-8">
            <Link to="/" aria-label={`${BRAND.name} — Home`} className="inline-block">
              <img
                src="/dms-wedding-films-logo.png"
                alt="DMS Wedding Films"
                className="h-12 w-12 rounded-full object-contain"
              />
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-[1.8] text-muted-foreground">
              Luxury wedding photography &amp; cinematic films, preserving emotions for generations.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href={BRAND.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Visit DMS Wedding Films Instagram Profile" className="inline-flex h-10 w-10 items-center justify-center text-muted-foreground transition-colors hover:text-lux-gold">
                <Instagram className="h-5 w-5" />
              </a>
              <a href={BRAND.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Visit DMS Wedding Films Facebook Page" className="inline-flex h-10 w-10 items-center justify-center text-muted-foreground transition-colors hover:text-lux-gold">
                <Facebook className="h-5 w-5" />
              </a>
              <a href={BRAND.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="Subscribe to DMS Wedding Films YouTube Channel" className="inline-flex h-10 w-10 items-center justify-center text-muted-foreground transition-colors hover:text-lux-gold">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h3 className="micro-label">Explore</h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground transition-colors hover:text-lux-charcoal">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/privacy-policy" className="text-sm text-muted-foreground transition-colors hover:text-lux-charcoal">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="micro-label">Services</h3>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-sm text-muted-foreground transition-colors hover:text-lux-charcoal">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="micro-label mt-8">Service Areas</h3>
            <p className="mt-4 text-sm text-muted-foreground">{BRAND.serviceAreas.join(" \u00b7 ")}</p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="micro-label">Contact</h3>
            <ul className="mt-5 space-y-4">
              {BRAND.phoneFormatted.map((p) => (
                <li key={p}>
                  <a href={WA.phone(p.replace(/[^0-9]/g, "").slice(-10))} className="flex items-center gap-3 text-sm text-muted-foreground transition-colors hover:text-lux-charcoal">
                    <Phone className="h-4 w-4 flex-shrink-0 text-lux-gold" /> {p}
                  </a>
                </li>
              ))}
              <li>
                <a href={WA.mail()} data-testid="contact-email" className="flex items-center gap-3 text-sm text-muted-foreground transition-colors hover:text-lux-charcoal min-w-0">
                  <Mail className="h-4 w-4 flex-shrink-0 text-lux-gold" /> <span className="break-all min-w-0">{BRAND.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-lux-gold" />
                <span>Duplex No. 29, Duplex Society, Bhimpur, Forest Park, Bhubaneswar, Odisha 751020</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-border pt-8 sm:flex-row">
          <p className="text-xs tracking-[0.08em] text-muted-foreground">
            {"\u00A9"} {year} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs tracking-[0.12em] uppercase text-muted-foreground">
            Crafted with care {"\u00B7"} Timeless wedding stories
          </p>
        </div>
      </div>
    </footer>
  );
};
